<script setup>
// Config do node "Aprovação": antes de uma ação sensível, o agente pede
// confirmação ao cliente e/ou sinaliza pra um humano aprovar. Compilado na
// instrução do agente.
import { useI18n } from 'vue-i18n';

defineProps({ data: { type: Object, required: true } });
const emit = defineEmits(['update', 'remove', 'close']);
const { t } = useI18n();

const onField = (key, event) => emit('update', { [key]: event.target.value });
const onToggle = (key, current) => emit('update', { [key]: !current });
</script>

<template>
  <div class="p-4">
    <div class="mb-1 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <span class="i-lucide-circle-check text-n-slate-11" />
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ data.label || t('AI_AGENTS.FLOW.APPROVE.TITLE') }}
        </h3>
      </div>
      <button class="i-lucide-x text-n-slate-10" @click="emit('close')" />
    </div>
    <p class="mb-3 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.APPROVE.SUBTITLE') }}
    </p>

    <label class="mb-1 block text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.APPROVE.WHAT') }}
    </label>
    <textarea
      :value="data.approvalPrompt"
      rows="2"
      :placeholder="t('AI_AGENTS.FLOW.APPROVE.WHAT_PH')"
      class="mb-3 w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
      @input="onField('approvalPrompt', $event)"
    />

    <label class="mb-1 block text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.APPROVE.QUESTION') }}
    </label>
    <textarea
      :value="data.confirmationQuestion"
      rows="2"
      :placeholder="t('AI_AGENTS.FLOW.APPROVE.QUESTION_PH')"
      class="mb-3 w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
      @input="onField('confirmationQuestion', $event)"
    />

    <label class="mb-1 block text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.APPROVE.ON_REJECT') }}
    </label>
    <input
      :value="data.onReject"
      :placeholder="t('AI_AGENTS.FLOW.APPROVE.ON_REJECT_PH')"
      class="mb-3 w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
      @input="onField('onReject', $event)"
    />

    <div class="flex items-center justify-between gap-2">
      <span class="text-sm text-n-slate-11">
        {{ t('AI_AGENTS.FLOW.APPROVE.NEEDS_HUMAN') }}
      </span>
      <button
        class="relative h-5 w-9 shrink-0 rounded-full transition-colors"
        :class="data.needsHuman ? 'bg-n-brand' : 'bg-n-slate-5'"
        @click="onToggle('needsHuman', data.needsHuman)"
      >
        <span
          class="absolute top-0.5 size-4 rounded-full bg-white transition-all"
          :class="data.needsHuman ? 'left-[18px]' : 'left-0.5'"
        />
      </button>
    </div>
    <p class="mt-2 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.APPROVE.HINT') }}
    </p>

    <button
      class="mt-4 w-full rounded-lg border border-n-ruby-7 py-2 text-sm font-medium text-n-ruby-9 hover:bg-n-ruby-3"
      @click="emit('remove')"
    >
      {{ t('AI_AGENTS.FLOW.REMOVE_NODE') }}
    </button>
  </div>
</template>
